var SCM = SCM || {};

SCM.JumpLinks = (function ($) {
    const ScrollAnimationDurationInMs = 500;
    const NoToolbarTargetBuffer = 32;
    const FocusableSelector = 'a[href], button:not([disabled]), input:not([type="hidden"]):not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])';
    var $jumpLinks;
    var $chapterJumpLinks;

    return {
        init: init,
        moveFocusAfterTarget: moveFocusAfterTarget,
        moveFocusWithinTarget: moveFocusWithinTarget,
        resolveJumpLinkTarget: resolveJumpLinkTarget,
        scrollToTarget: scrollToTarget
    };

    function configureGbosJumpLinks() {
        if ($('.pg_gboscontent').length) {

            if ($('.page-column--left').length) {
                $(window).on('scroll', function () {
                    if ($(window).width() < 900) {
                        var scroll = $(this).scrollTop();
                        if (scroll < $('.page-column--center').offset().top - 65) {
                            $('.page-column--left').removeClass('stuck');
                        } else {
                            $('.page-column--left').addClass('stuck');
                        }
                    }
                });
            }

            $('.js-jumplinks-trigger').on('click', function () {
                $('.jumplink-list').toggleClass('open');
            });

        }
    }

    function init() {
        // articles, issues
        configureJumpLinks();
        // chapters
        configureChapterJumpLinks();   
        // GBOS
        configureGbosJumpLinks();
        //articles, chapters
        registerFootNotesLink();
        configureJumplinksOnChapterStandardPage();
    }

    function configureJumplinksOnChapterStandardPage() {
        $('.book-chapter-body').not('.js-content-splitview .book-chapter-body').on('click', 'a[href^="#"]:not([href="#"])', function (e) {
            e.preventDefault();
            let targetId = $(this).attr('href').substring(1);
            let targetElement = document.getElementById(targetId);
            
            if (targetElement) {
                scrollToTarget($(targetElement));

                setTimeout(function () {
                    history.pushState(null, null, '#' + targetId);
                }, 500);
            }
        });
    }

    function configureJumpLinks() {
        $jumpLinks = $('.jumplink-list, .jumplink-list-flyout, .list-issue-jumplinks');        

        if (!$jumpLinks.length) {
            return;
        }
        smoothScroll();
        jumpLinkKeyboardNav();
        scrollHighlight();
        secJumpLink();
        triggerJumpLinkFlyout();
        addExtraJumpLinks();
        fixJumpLinkOrdering();
        hideIfNoJumpLinks();
        addJumpLinkEvents();
    }

    function configureChapterJumpLinks() {

        $chapterJumpLinks = $('.js-list-book-jumplinks');
        if (!$chapterJumpLinks.length) {            
            return;
        }

        var $customJumpLinks = $chapterJumpLinks.find('.js-custom-section-jump-link');
        var $regularJumpLinks = $chapterJumpLinks.find('.js-section-jump-link');

        if (!$customJumpLinks.length && !$regularJumpLinks.length) {
            return;
        }

        // for each custom jump-link, hide it if target element doesnt exists.
        $customJumpLinks.each(function () {
            var targetElement = $(this).data('targetid');
            if (!$(targetElement).length) {
                $(this).hide();
            }
        });

        // if no regularjumplinks and all of the customJumpLinks are hidden, then hide entire jumplinks
        if (!$regularJumpLinks.length && !$customJumpLinks.not('.hide').length) {
            var $jumpLinkWrapper = $chapterJumpLinks.parents('.js-section-jump-link-wrapper');
            if ($jumpLinkWrapper.length) {
                $jumpLinkWrapper.hide();
            }            
        }

        smoothScroll();
        scrollHighlight();
    }

    function registerFootNotesLink() {
        $('.js-end-note-link').on('click', function (e) {
            var footnoteId = $(this).attr('data-fn-id');
            var bookId = $("#BookId").val();
            var isArticle = $('.widget-ArticleFulltext').length > 0;
            var $contentBody = getContentBody();
            if (footnoteId && footnoteId.length) {
                var $noteLink;
                if (isArticle) {
                    $noteLink = $('.content-inner-wrap:visible .js-xref-fn[reveal-id="' + footnoteId + '"]:visible');
                    // special case for table-modals that are marked display:block and visibility:hidden
                    // Have to filter those out and only look at ones not in the modal
                    if ($noteLink.length > 1) {
                        $noteLink = $noteLink.filter(function (idx) {
                            var $parent = $($noteLink[idx]).closest('.table-modal.table-full-width-wrap');
                            return ($parent.length === 0);
                        });
                        $noteLink = $noteLink.first();
                    }
                }
                else {
                    $noteLink = $contentBody.find('.js-xref-fn[reveal-id="' + footnoteId + '"]:first');
                }
                if ($noteLink.length === 0 && bookId.length) {
                    $noteLink = $contentBody.find('.js-related-object[legacysectionid="' + footnoteId + '"]:first');
                }
                if ($noteLink.length) {
                    scrollToTarget($noteLink);
                }
            }
        });
    }

    function getContentBody() {
        if ($('.js-content-splitview').length)
        { 
            return $('.js-content-splitview');
        }
        else
        {
            return $('.js-content-standard');
        }
    }

    function escapePeriods(string) {
        if (string) {
            string = string.replace(/[.]/g, '\\.');
        }
        return string;
    }

    // Resolve a jump-link anchor to its destination element: prefer the
    // data-scrollto -> data-legacyid mapping, fall back to the href hash.
    function resolveJumpLinkTarget(linkEl) {
        var targetLegacyId = escapePeriods($(linkEl).data('scrollto'));
        var $targetLegacy = $('[data-legacyid=' + targetLegacyId + ']');
        if ($targetLegacy.length) {
            return $targetLegacy;
        }
        return $(escapePeriods(linkEl.hash));
    }

    function scrollToTarget($target, onComplete) {
        if (!$target.length) {
            return;
        }
        SCM.Utilities.LazyLoad.disable();
        const newOnComplete = function () {
            SCM.Utilities.LazyLoad.enable();
            onComplete && onComplete();
        }
        if ($('.pg_articlesplitview').length) {
            scrollToTargetSplitView($target, newOnComplete);
        } else {
            scrollToTargetDefault($target, newOnComplete);
        }
    }

    function scrollToTargetSplitView($target, onComplete) {
        var $splitViewContent = $('.js-content-splitview');
        if ($splitViewContent.length) {
            $splitViewContent.animate({
                scrollTop: $target.offset().top +
                    $splitViewContent.scrollTop() -
                    $splitViewContent.offsetParent().offset().top
            },
                ScrollAnimationDurationInMs, onComplete);
        } else {
            $('html,body').animate({
                scrollTop: $target.offset().top
            },
                ScrollAnimationDurationInMs, onComplete);
        }
    }

    function forceToolbarStuck() {
        var $toolbar = $('.toolbar-wrap');
        if ($toolbar.length && !$toolbar.hasClass('toolbar-stuck')) {
            $toolbar.addClass('toolbar-stuck');
        }
    }

    function getTargetPixelBuffer() {
        var $toolbar = $('.toolbar-wrap');
        if ($toolbar.length) {
            return $toolbar.outerHeight();
        }
        return NoToolbarTargetBuffer;
    }

    function scrollToTargetDefault($target, onComplete) {
        forceToolbarStuck();
        $('html,body').animate({
            scrollTop: $target.offset().top - getTargetPixelBuffer()
        }, ScrollAnimationDurationInMs, onComplete);
    }

    function moveFocusAfterTarget($target) {
        var targetEl = $target && $target[0];
        if (!targetEl) {
            return;
        }
        var candidates = document.querySelectorAll(FocusableSelector);
        for (var i = 0; i < candidates.length; i++) {
            var el = candidates[i];
            var relation = targetEl.compareDocumentPosition(el);
            var isAfter = (relation & Node.DOCUMENT_POSITION_FOLLOWING) !== 0;
            var isContained = (relation & Node.DOCUMENT_POSITION_CONTAINED_BY) !== 0;
            if (isAfter && !isContained && $(el).is(':visible')) {
                el.focus({ preventScroll: true });
                return;
            }
        }
        if (!targetEl.hasAttribute('tabindex')) {
            targetEl.setAttribute('tabindex', '-1');
        }
        targetEl.focus({ preventScroll: true });
    }

    function moveFocusWithinTarget($target) {
        var targetEl = $target && $target[0];
        if (!targetEl) {
            return;
        }
        var firstFocusable = targetEl.querySelector(FocusableSelector);
        if (firstFocusable && $(firstFocusable).is(':visible')) {
            firstFocusable.focus({ preventScroll: true });
            return;
        }
        if (!targetEl.hasAttribute('tabindex')) {
            targetEl.setAttribute('tabindex', '-1');
        }
        targetEl.focus({ preventScroll: true });
    }

    function secJumpLink() {
        $(document).on('click', 'a.js-sec-jumplink', function () {
            if (location.pathname.replace(/^\//, '') === this.pathname.replace(/^\//, '') && location.hostname === this.hostname) {
                var targetLegacyId = $(this).data('scrollto');

                //"includes" does not work in IE11, must use indexOf
                if (targetLegacyId.indexOf(' ') > 0) {
                    targetLegacyId = targetLegacyId.split(' ')[0];
                }
                targetLegacyId = escapePeriods(targetLegacyId);

                var $target = $('[data-legacyid=' + targetLegacyId + ']');
                scrollToTarget($target);
            }
        });
    }

    function smoothScroll() {
        $('body').on('click', 'a[href*="#"]:not([href="#"])', function (e) {
            if (location.pathname.replace(/^\//, '') === this.pathname.replace(/^\//, '') && location.hostname === this.hostname) {
                e.preventDefault();
                // Scope the focus-move to the article Contents jumplinks only;
                // other in-page anchors keep their existing behavior.
                var isJumpLink = $(this).hasClass('jumplink');
                var $target = resolveJumpLinkTarget(this);
                scrollToTarget(
                    $target,
                    isJumpLink
                        ? function () { moveFocusAfterTarget($target); }
                        : undefined
                );
            }
            else if ($(this).hasClass('SupplementaryDataLink')) {
                e.preventDefault();
                window.location = $(this).attr('href');
            }
        });
    }

    // WCAG 2.4.3 (ACS-1294): a forward Tab from a focused section jump-link must
    // move focus into that section's content, not on to the next jump-link label.
    // Reuses the click path (scrollToTarget -> moveFocusAfterTarget). Shift+Tab is
    // left to the browser so inactive labels stay reachable backward. Scoped to the
    // article Contents strip (.jumplink-list and its mobile flyout) so Issue ToC
    // (.list-issue-jumplinks, which also uses a.jumplink), book chapters, and the
    // comments jump-link keep their existing behavior.
    function jumpLinkKeyboardNav() {
        $('body').on('keydown', '.jumplink-list a.jumplink, .jumplink-list-flyout a.jumplink', function (e) {
            if (e.which !== 9 || e.shiftKey) {
                return;
            }
            // Not in split view: there the Contents jump-links are the content of a
            // tab panel sitting in the opposite pane from the article, so entering
            // the target section throws focus across the split at the very first
            // jump-link and leaves the rest of the panel unreachable by keyboard
            // (ACS-1348 Scenario 5). Tab therefore stays native inside the aside and
            // walks the Contents list. Activating a jump-link still moves focus into
            // the section - split view runs moveFocusAfterTarget from its own click
            // handler in client.splitscreen.js - so the ACS-1294 intent is preserved
            // on the activation path.
            if ($(this).closest('.js-splitview-aside').length) {
                return;
            }
            if (location.pathname.replace(/^\//, '') !== this.pathname.replace(/^\//, '') || location.hostname !== this.hostname) {
                return;
            }
            var $target = resolveJumpLinkTarget(this);
            if (!$target.length) {
                return;
            }
            e.preventDefault();
            scrollToTarget($target, function () {
                moveFocusAfterTarget($target);
            });
        });
    }

    function scrollHighlight() {
        scrollHighlightBookChapter();
        scrollHighlightArticleIssue();
        scrollHighlightGbos();     
    }   

    function scrollHighlightGbos() {
        if (!$('.pg_GbosContent').length) {
            return;
        }
        $(window).on('scroll', function () {
            var scrollTop = $(this).scrollTop();
            if (!$('.widget-GbosFulltext').length) {
                return;
            }
            $('h2').each(function () {
                var topDistance = $(this).offset().top;
                var subheadingArticleId = $(this).data('magellan-destination');
                var scrollToLink = $('.section-jump-link a[href="#' + subheadingArticleId + '"]');
                // if section is in view
                if (topDistance - 65 < scrollTop) {
                    if ($(scrollToLink).length) {
                        $('.section-jump-link.active').removeClass('active');
                        $(scrollToLink).closest('.section-jump-link').addClass('active');
                    }
                }
            });
        });
    }

    function scrollHighlightBookChapter() {

        if (!$('.pg_ChapterStandard').length) {
            return;
        }
        $(window).on('scroll', function () {
            var scrollTop = $(this).scrollTop();
            if (!$('.book-chapter-body').length) {
                return;
            }
           
            $('.jumplink-heading').each(function () {
                var topDistance = $(this).offset().top;
                var subheadingArticleId = $(this).data('magellan-destination');
                var scrollToLink = $('.section-jump-link a[href="#' + subheadingArticleId + '"]');
                // if section is in view
                if (topDistance - 100 < scrollTop) {
                    if ($(scrollToLink).length) {
                        $('.section-jump-link.active').removeClass('active');
                        $(scrollToLink).closest('.section-jump-link').addClass('active');
                    }
                }
            });
            addLevel2ClassForH3Links('data-magellan-destination');
        });
    }

    function addLevel2ClassForH3Links(idAttributeName) {
        $('h3').each(function () {
            var subheadingArticleId = $(this).attr(idAttributeName);            
            var scrollToLink = $('.section-jump-link a[href="#' + subheadingArticleId + '"]');
            $(scrollToLink).closest('.section-jump-link').addClass('level-2');
        });
    }

    function scrollHighlightArticleIssue() {
        if (!$('.pg_Article').length && !$('.pg_Issue').length && !$('.pg_ConferenceVolume').length && !$('.pg_proceeding').length) {
            return;
        }
        $(window).on('scroll', debounce(windowOnScroll, 100));
    }

    function windowOnScroll() {
            var scrollTop = $(this).scrollTop();
            $('.articleClientType').each(function () {
                var topDistance = $(this).offset().top;
                var subheadingArticleId = $(this).attr('id');
                var scrollToLink = $('.section-jump-link__link-wrap a[href="#' + subheadingArticleId + '"]');
                // if section is in view
                if (topDistance - 80 < scrollTop) {
                    if ($(scrollToLink).length) {
                        $('.list-issue-jumplinks li').removeClass('active');
                    }
                    $(scrollToLink).closest('.section-jump-link').addClass('active');
                }
            });
            if ($('.article-body').length) {
                $('h2, .jumplink-heading').each(function () {
                    var topDistance = $(this).offset().top;
                    var subheadingArticleId = $(this).attr('id');
                    var scrollToLink = $('.section-jump-link__link-wrap a[href="#' + subheadingArticleId + '"]');
                    // if section is in view
                    if (topDistance - 80 < scrollTop) {
                        if ($(scrollToLink).length) {
                            $('.jumplink-list li, .jumplink-list-flyout li').removeClass('active');
                        }
                        $(scrollToLink).closest('.section-jump-link').addClass('active');
                        if ($('.active-section').length) {
                            $('.active-section').text($('.section-jump-link.active a').text());
                        }
                    }
                });

                // Force add active class to last section when there isn't enough content below it to automatically trigger it.
                const isAtPageBottom = scrollTop + $(window).height() >= $(document).height() - 10;
                if (isAtPageBottom) {
                    const $jumpLinkItems = $('.jumplink-list .js-article-jump-link');
                    $jumpLinkItems.removeClass('active');
                    $jumpLinkItems.last().addClass('active');
                }

                addLevel2ClassForH3Links('id');
            }
    }

    function triggerJumpLinkFlyout() {
        if ($('.pg_Article').length && $('.jumplink-list-flyout').length) {
            $('.js-jumplink-flyout-trigger').on('click', function (e) {
                e.stopPropagation();
                $('.jumplink-list-flyout-container').toggleClass('active');
            });
            $(document.body).on('click', function () {
                $('.jumplink-list-flyout-container').removeClass('active');
            });

        }
    }

    function addExtraJumpLinks() {
        var jumpLinkConfigurations = [
            { // Author Notes
                titleElementSelector: '.authorNotes-section-title',
                wrapperClass: 'author-notes-jumplink',
                targetId: 'authorNotesSectionTitle'
            },
            { // Foot Notes
                titleElementSelector: '.footNotes-section-title',
                wrapperClass: 'foot-notes-jumplink',
                targetId: 'footNotesSectionTitle'
            },
            { // Competing Interests
                titleElementSelector: '.coiStatement-section-title',
                wrapperClass: 'coi-statement-jumplink',
                targetId: 'coiStatementSectionTitle'
            },
            { // Supplemental Data
                titleElementSelector: '.content-inner-wrap .supplementary-data-section-title',
                wrapperClass: 'datasupplements-section-jumplink',
                targetId: 'supplementary-data'
            },
            { // UserComments
                titleElementSelector: '.js-comments-title',
                wrapperClass: 'usercomments-section-jumplink',
                targetId: 'userComments',
                linkHtmlSelector: '.js-comments-jumplink'
            },
            { // PeerReview
                titleElementSelector: '.js-peer-review-title',
                wrapperClass: 'peerreview-section-jumplink',
                targetId: 'peer-review'
            }

        ];

        jumpLinkConfigurations.forEach(function(config) {
            var destinationTitle = $(config.titleElementSelector).first().text().trim();
            var linkInnerHtml = $(config.linkHtmlSelector).first().length ? $(config.linkHtmlSelector).first().html() : undefined;
            if (destinationTitle) {
                addJumpLink({ title: destinationTitle, targetId: config.targetId, wrapperClass: config.wrapperClass, linkHtml: linkInnerHtml });
            }
        });

    }

    /**
     * @typedef {Object} JumpLink
     * @property {string} wrapperClass
     * @property {string} targetId
     * @property {string} title
     * @property {string} linkHtmlSelector
     */

    /**
     * @param {JumpLink} jumpLink
     */
    function addJumpLink(jumpLink) {

        const jumpLinkHtml = jumpLink.linkHtml ? jumpLink.linkHtml : `<a class="jumplink scrollTo" href="#${jumpLink.targetId}">${jumpLink.title}</a>`;
        const jumpLinkWrapper = `<li class="section-jump-link js-article-jump-link head-1 ${jumpLink.wrapperClass}"><div class="section-jump-link__link-wrap">${jumpLinkHtml}</div></li>`;

        $jumpLinks.append(jumpLinkWrapper);
    }

    function fixJumpLinkOrdering() {
        // We have so hacked up the article sections and the JumpLinks list that there are scenarios where
        // the list of JumpLinks is out of order.  This method will align the order of the jumpLinks to the 
        // order of the destinations as they appear in the DOM
        var $jumpLinksItems = $jumpLinks.find('li').has('.jumplink');
        if (!$jumpLinksItems.length) {
            return;
        }

        var scrollDestinations = $('#ContentColumn [scrollto-destination]');
        if (!scrollDestinations.length) {
            return;
        }

        var reorderedList = scrollDestinations
            .map(function (i, item) {
                return $jumpLinksItems.has(`[href="#${item.getAttribute('scrollto-destination')}"]`)
                    .first()
                    .get();
            });

        // detach to ensure that they retain their existing event handlers
        $jumpLinks.children()
            .detach();
        $jumpLinks
            .empty()
            .append(reorderedList);
    }

    function hideIfNoJumpLinks() {
        if (!$jumpLinks.find('li').length) {
            var $widgetArticleJumpLinks = $jumpLinks.parents('.widget-ArticleJumpLinks');
            if ($widgetArticleJumpLinks.length && !$widgetArticleJumpLinks.find('.js-jumplink').length) {
                $widgetArticleJumpLinks.hide();
            }            
        }
    }

    function addJumpLinkEvents() {
        //comments jumplink on splitview
        var $targetTab = $('.tab-split-view-comments-pane');
        if ($targetTab.length) {
            $('.js-comments-jumplink .js-jumplink').on('click', function (e) {
                e.preventDefault();                
                if (!$targetTab.hasClass('active')) {
                    // If the tab is NOT active, have to switch over to it
                    $targetTab.click();
                }
            });
        }     
    }    


})(jQuery);



